module.exports = __webpack_public_path__ + "static/img/wly.e47c3e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/footer/wly.png
// module id = wm6P
// module chunks = 3